import cn from 'classnames';
import { ArticleHeading4, ArticleParagraph1, IconFavoriteOn16, Image } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IRealtorCardProps {
  isBig?: boolean;
  name: string;
  rating: string;
  reviews: string;
  img: string;
}

export const RealtorCard: React.FC<IRealtorCardProps> = ({ isBig, name, rating, reviews, img }) => {
  const imgSize = isBig ? '100px' : '60px';

  return (
    <div className={cn(styles['card'], isBig && styles['card-big'])}>
      <div>
        <div className={styles['card-title']}>
          <ArticleHeading4>{name}</ArticleHeading4>
        </div>
        <div className={styles['card-content']}>
          <div className={styles['rating']}>
            <IconFavoriteOn16 color="warning_100" />
            <div className={styles['rating-value']}>
              <ArticleHeading4 color="warning_100">{rating}</ArticleHeading4>
            </div>
          </div>
          <div className={styles['reviews']}>
            <ArticleParagraph1>{reviews}</ArticleParagraph1>
          </div>
        </div>
      </div>
      <div className={styles['img']}>
        <Image src={img} width={imgSize} height={imgSize} borderRadius="50%" />
      </div>
    </div>
  );
};

RealtorCard.displayName = 'RealtorCard';
